var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 5.78125C17.0312 5.625 17.0312 5.40625 16.875 5.25L13.75 2.125C13.5938 1.96875 13.3438 1.96875 13.2188 2.125L12.5938 2.75C12.4375 2.875 12.4375 3.125 12.5938 3.28125L14.1875 4.75H1.375C1.15625 4.75 1 4.9375 1 5.125V5.875C1 6.09375 1.15625 6.25 1.375 6.25H14.1875L12.5938 7.75C12.4375 7.90625 12.4375 8.15625 12.5938 8.28125L13.2188 8.90625C13.3438 9.0625 13.5938 9.0625 13.75 8.90625L16.875 5.78125ZM1.09375 11.7812L4.21875 14.9062C4.375 15.0625 4.625 15.0625 4.75 14.9062L5.375 14.2812C5.53125 14.1562 5.53125 13.9062 5.375 13.75L3.78125 12.25H16.625C16.8125 12.25 17 12.0938 17 11.875V11.125C17 10.9375 16.8125 10.75 16.625 10.75H3.78125L5.375 9.28125C5.53125 9.125 5.53125 8.875 5.375 8.75L4.75 8.125C4.625 7.96875 4.375 7.96875 4.21875 8.125L1.09375 11.25C0.9375 11.4062 0.9375 11.625 1.09375 11.7812Z",
    fill: "#07080C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterchange);
export default __webpack_public_path__ + "static/media/interchange.839633b4ccfbe9af5cef6172570db572.svg";
export { ForwardRef as ReactComponent };